import * as React from "react";
import { Text } from "../../../ui/components/Text";
import { Button } from "../../../ui/components/Button";
import { Modal } from "../../../ui/components/Modal";
import { JoinOrganizationSearch } from "../organizations/JoinOrganizationSearch";
import { CreateOrganizationModal } from "./CreateOrganizationModal";
import { useAuth } from "../../lib/auth/hooks";
import type { User } from "../../lib/api/users";

export interface JoinOrganizationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  user?: User | null;
  onDone?: () => void;
  onMembershipChange?: () => void;
}

export function JoinOrganizationModal({
  open,
  setOpen,
  user: userProp,
  onDone,
  onMembershipChange,
}: JoinOrganizationModalProps) {
  const { user: authUser, refreshUser } = useAuth();
  const user = userProp ?? authUser;
  const [createModalOpen, setCreateModalOpen] = React.useState(false);

  const handleDone = () => {
    setOpen(false);
    onDone?.();
  };

  return (
    <>
      <Modal
        open={open}
        setOpen={setOpen}
        minWidth="520px"
        maxWidth="520px"
        minHeight="auto"
        maxHeight="85vh"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            padding: "8px 4px 4px",
          }}
        >
          <Text level="h3" weight="bold">
            Join an existing organization
          </Text>

          <JoinOrganizationSearch
            user={user}
            active={open}
            onMembershipChange={() => {
              void refreshUser();
              onMembershipChange?.();
            }}
          />

          <Button
            type="button"
            color="primary"
            variant="solid"
            fullWidth
            size="lg"
            onClick={handleDone}
          >
            Done
          </Button>

          <Button
            type="button"
            color="neutral"
            variant="outline"
            fullWidth
            size="lg"
            onClick={() => {
              setOpen(false);
              setCreateModalOpen(true);
            }}
          >
            Create an organization
          </Button>
        </div>
      </Modal>
      <CreateOrganizationModal
        open={createModalOpen}
        setOpen={setCreateModalOpen}
        onCreated={() => onDone?.()}
      />
    </>
  );
}
